@use "../../sass/global/global" as *;

.ux-iws-asset-image-manager {
    display: block;

    &__images {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        margin-bottom: 30px;
        width: 100%;
    }

    &__drop-zone {
        width: 30px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__image {
        width: 210px;
        height: 120px;
        min-width: 90px;
        max-width: 500px;
        position: relative;
        overflow: hidden;

        img,
        ux-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
            display: block;
        }

        ux-button {
            position: absolute;
            bottom: 0;
            right: 0;
        }

        &-disclaimer {
            position: absolute;
            bottom: 0;
            height: 21px;
            width: 100%;
            text-align: center;
            background-color: $color-black-3;
            color: $color-white;
        }
    }

    &__display-img-btn {
        all: unset;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        height: 21px;
        width: 100%;
        text-align: center;
        background-color: $color-white;
        color: $color-blue-highlight-1;
        border: 1px solid $color-blue-highlight-1;
        z-index: 1;
        display: flex;
        justify-content: center;
        cursor: pointer;

        &--active {
            background-color: $color-blue-highlight-1;
            color: $color-white;
            border: unset;
        }
    }

    &__image-tag {
        position: absolute;
        top: 10px;
        left: 0;
    }

    &__drop-indicator {
        width: 4px;
        background: $color-green;
        height: 120px;
        display: inline-block;
        margin: 0 4px;
        border-radius: 5px;
    }
}
